<template>
<div id="mypage">
    <div class="my_page_popup hidden-scroll">
        <div class="my_page_wrap">
            <!-- <h1>마이페이지</h1> -->
            <div class="my_poroduct">
                <!-- <div class="mystore">
                    {{store_name}}<span @click="store_change">매장변경</span>
                </div> -->
                <div class="mymileage"><div class='mileage-wrap'><p class="m-icon">m</p>마일리지  <span class="point-text"><mileage />P</span></div><div class="mileage-btn" @click="payment_mileage"><font-awesome-icon :icon="['fas', 'plus']" /></div></div>
                <div class="use_btn btn-ok pw_letter" @click="change_password_modal">비밀번호 변경</div>
                <div class="status-legend">
                    <div>
                        <div class="stat-box usable"></div>
                        <span>사용가능</span>
                    </div>
                    <div>
                        <div class="stat-box before"></div>
                        <span>사용전</span>
                    </div>
                    <div>
                        <div class="stat-box using"></div>
                        <span>사용중</span>
                    </div>
                    <div>
                        <div class="stat-box reser-com"></div>
                        <span>예약완료</span>
                    </div>
                </div>
                <p class="tb-title">내 좌석상품목록</p>
                <div class="table-wrapper">
                    <table class="tb_mypage_b">
                        <colgroup>
                                <col width="5%;" />
                                <col width="13%;" />
                                <col width="25%;" />
                                <col width="17%;" />
                                <col width="25%;" />
                                <col width="15%;" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>상태</th>
                                <th>좌석타입</th>
                                <th>이용상품</th>
                                <th>이용시간</th>
                                <th>이용가능기간</th>
                                <th>남은시간</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="my_productList.length != 0">
                                <tr v-for="item in my_productList" :key="item.seat_purchase_history_id">
                                    <td>
                                        <div v-if="item.code == 'WAITING'" class="stat-box before in_use"></div>
                                        <div v-if="item.code == 'AVAILABLE'" class="stat-box usable in_use"></div>
                                        <div v-if="item.code == 'USING'" class="stat-box using in_use"></div>
                                    </td>
                                    <td>{{item.seat_type_name}}</td>
                                    <td>{{item.goods_group_name}}</td>
                                    <td>{{item.goods_time}}</td>
                                    <template v-if="item.use_end_datetime !== null">
                                        <td>{{item.use_end_datetime}}</td>
                                    </template>
                                    <template v-else>
                                        <td>-</td>
                                    </template>
                                    <td>{{item.str_left_time}}</td>
                                </tr>
                            </template>
                            <template v-else>
                                <tr>
                                    <td colspan="6" class="no-list">상품 목록이 존재하지 않습니다.</td>
                                </tr>
                            </template>
                            <!-- <td><span class="on_call">대기중</span></td> -->
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="my_coupon">
                <p class="tb-title">내 쿠폰목록</p>
                <div class="table-wrapper">
                    <table class="tb_mypage">
                        <colgroup>
                                <col width="5%;" />
                                <col width="20%;" />
                                <col width="15%;" />
                                <col width="30%;" />
                                <col width="25%;" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>상태</th>
                                <th>이용상품</th>
                                <th>이용시간</th>
                                <th>이용가능기간</th>
                                <th>남은시간</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="my_couponList.length != 0">
                                <tr v-for="item in my_couponList" :key="item.seat_coupon_user_id">
                                    <td>
                                        <div v-if="item.code == 'WAITING'" class="stat-box before in_use"></div>
                                        <div v-if="item.code == 'AVAILABLE'" class="stat-box usable in_use"></div>
                                        <div v-if="item.code == 'USING'" class="stat-box using in_use"></div>
                                    </td>
                                    <td>{{item.goods_group_name}}</td>
                                    <td>{{item.goods_time}}</td>
                                    <!-- <td><span class="in_use">{{item.name}}</span></td> -->
                                    <!-- <td>{{item.str_use_total_time}}</td> -->
                                    <td>{{item.use_end_datetime}}</td>
                                    <td>{{item.str_left_time}}</td>
                                </tr>
                            </template>
                            <template v-else>
                                <tr>
                                    <td colspan="5" class="no-list">상품 목록이 존재하지 않습니다.</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="my_using_menu fixedd">
                <p class="tb-title">내 좌석 정보</p>
                <div class="table-wrapper">
                    <table class="tb_mypage">
                        <colgroup>
                                <col width="15%;" />
                                <col width="15%;" />
                                <col width="35%;" />
                                <col width="35%;" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>좌석</th>
                                <th>상태</th>
                                <th>시작시간</th>
                                <th>종료시간</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="my_using_seat" v-for="(item , index) in myseat_info" :key="index">
                                <td>{{item.seat_name}}</td>
                                <td>{{item.code_name}}</td>
                                <td>{{item.use_start_datetime}}</td>
                                <td>{{item.use_end_datetime}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>    
                               

                <div class="my_using_locker" v-for="item in mylocker_info" :key="item.locker_id" style="margin-bottom:10px;">
                    <p class="tb-title">내 사물함 정보</p>
                    <div class="table-wrapper">
                        <table class="tb_mypage">
                            <colgroup>
                                    <col width="15%;" />
                                    <col width="15%;" />
                                    <col width="35%;" />
                                    <col width="35%;" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>사물함</th>
                                    <th>상태</th>
                                    <th>시작시간</th>
                                    <th>종료시간</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="my_using_locker" v-for="item in mylocker_info" :key="item.locker_id">
                                    <td>{{item.locker_name}}</td>
                                    <td>{{item.code_name}}</td>
                                    <td>{{item.use_start_datetime}}</td>
                                    <td>{{item.use_end_datetime}}</td>
                                </tr>
                            </tbody>
                        </table>
                    
                    </div>
                </div>
            </div>

            <div class="my_group_menu" v-if="continue_seat_purchase_history_flag">
                <p class="tb-title">내 좌석 연장 정보</p>
                <div class="table-wrapper">
                    <table class="tb_mypage">
                        <thead colspan="3">
                            <tr >
                                <th style="width:328px;">상품명</th>
                                <th style="width:322px;">시작시간</th>
                                <th style="width:330px;">종료시간</th>
                            </tr>
                        </thead>

                        <tbody>
                            <template>
                                <tr>
                                    <td>{{useinfo_exten_seat_item_name}}</td>
                                    <td>{{my_seat_end_time}}</td>
                                    <td>{{useinfo_exten_seat_item_time}}</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="my_group_menu">
                <p class="tb-title">내 그룹룸 상품목록</p>
                <div class="table-wrapper">
                    <table class="tb_mypage">
                        <colgroup>
                                <col width="5%;" />
                                <col width="25%;" />
                                <col width="25%;" />
                                <col width="30%;" />
                                <col width="15%;" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>상태</th>
                                <th>그룹룸 타입</th>
                                <th>이용상품</th>
                                <th>이용가능기간</th>
                                <th>남은시간</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="mygroom_info.length != 0">
                                <tr v-for="item in mygroom_info" :key="item.groom_purchase_history_id">
                                    <td>
                                        <div v-if="item.use_status_code == 'WAITING'" class="stat-box before in_use"></div>
                                        <div v-if="item.use_status_code == 'AVAILABLE'" class="stat-box usable in_use"></div>
                                        <div v-if="item.use_status_code == 'USING'" class="stat-box using in_use"></div>
                                    </td>
                                    <td>{{item.type_name}}</td>
                                    <td>{{item.goods_group_name}}</td>
                                    <td>{{item.use_end_datetime}}</td>
                                    <td>{{item.str_left_hours}}</td>
                                </tr>
                            </template>
                            <template v-else>
                                <tr>
                                    <td colspan="5" class="no-list">그룹룸 관련 상품 목록이 존재하지 않습니다.</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="my_group_list">
                <p class="tb-title">내 그룹룸 예약/사용 목록</p><p style="font-size: 0.7em;margin-left: 10px;color: #f99847;">(3개월 이내 예약건)</p>
                <div class="table-wrapper">
                    <table class="tb_mypage_a">
                        <colgroup>
                                <col width="5%;" />
                                <col width="5%;" />
                                <col width="17%;" />
                                <col width="23%;" />
                                <col width="25%;" />
                                <col width="25%;" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>상태</th>
                                <th>번호</th>
                                <th>그룹룸</th>
                                <th>이용상품</th>
                                <th>시작시간</th>
                                <th>종료시간</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="mygroom_reser.length != 0 || mygroom_using.length != 0">
                                <tr v-for="(item, index) in mygroom_using" :key="'groom_using'+index">
                                    <td>
                                        <div class="stat-box using in_use"></div>
                                    </td>
                                    <td>{{(index+1)}}</td>
                                    <td>{{item.groom_name}}</td>
                                    <td>{{item.goods_group_name}}</td>
                                    <td>{{item.start_datetime}}</td>
                                    <td>{{item.end_datetime}}</td>
                                </tr>
                                <!--<template v-if="down_mygroom_reser.length >0">
                                    <tr v-for="(item, index) in down_mygroom_reser" :key="'groom_reser'+index">
                                        <td>
                                            <div class="stat-box in_use reser-com"></div>
                                        </td>
                                        <td>{{(down_mygroom_reser.index+index+1)}}</td>
                                        <td>{{item.groom_name}}</td>
                                        <td>{{item.goods_group_name}}</td>
                                        <td>{{item.start_datetime}}</td>
                                        <td>{{item.end_datetime}}</td>
                                    </tr>
                                </template>--> 
                               
                                <tr v-for="(item, index) in mygroom_reser" :key="'groom_reser'+index">
                                    <td>
                                        <div class="stat-box in_use reser-com"></div>
                                        <!-- <span v-if="item.code === 'RESERVATION_COMPLETE'" class="in_use">{{item.name}}</span>
                                        <span v-if="item.code === 'RESERVATION_NOT_PAY'" class="in_use" @click="go_reservation_pay(item)">결제하기</span> -->
                                    </td>
                                    <td>{{(mygroom_reser.index+index+1)}}</td>
                                    <td>{{item.groom_name}}</td>
                                    <td>{{item.goods_group_name}}</td>
                                    <td>{{item.start_datetime}}</td>
                                    <td>{{item.end_datetime}}</td>
                                </tr> 
                            </template>
                            <template v-if="mygroom_reser.length == 0 && mygroom_using.length == 0">
                                <tr>
                                    <td colspan="6" class="no-list">그룹룸 관련 예약/사용 목록이 존재하지 않습니다.</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- 250724 그룹룸 이용내역 추가 -->
            <div class="my_group_list">
                <p class="tb-title">내 그룹룸 이용내역</p><p style="font-size: 0.7em;margin-left: 10px;color: #f99847;">(최근 5건)</p>
                <div class="table-wrapper">
                    <table class="tb_mypage_a">
                        <colgroup>
                                <!-- <col width="5%;" /> -->
                                <col width="10%;" />
                                <col width="25%;" />
                                <col width="25%;" />
                                <!-- <col width="10%;" /> -->
                                <col width="10%;" />
                        </colgroup>
                        <thead>
                            <tr>
                                <!-- <th>번호</th> -->
                                <th>그룹룸</th>
                                <th>시작시간</th>
                                <th>종료시간</th>
                                <!-- <th>이용방법</th> -->
                                <th>이용시간</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="mygroom_history_info.length != 0">
                                <tr v-for="(item, index) in mygroom_history_info" :key="'mygroom_history_info'+index">
                                    <!-- <td>{{(index+1)}}</td> -->
                                    <td>{{item.groom_name}}</td>
                                    <td>{{item.use_start_datetime}}</td>
                                    <td>{{item.use_end_datetime}}</td>
                                    <!-- <td>{{item.start_kind}}</td> -->
                                    <td>{{ item.use_hours ? item.use_hours + '분' : '' }}</td>
                                </tr>
                            </template>
                            <template v-if="mygroom_history_info.length == 0 ">
                                <tr>
                                    <td colspan="4" class="no-list">그룹룸 이용내역이 존재하지 않습니다.</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    </div>
    <pop ref="pop" />
    <modals-container />
</div>
</template>

<script>
import vue from 'vue';
import * as config from '../../javascript/config';
import mileage from "../components/mileage";
import pop from "../components/pop"

vue.component('mileage', mileage);
vue.component('pop', pop);
export default {
    name: 'mypage',
    data() {
        return {
            my_productList: [],
            my_couponList: [],
            myseat_info: [],
            mylocker_info: [],
            
            mygroom_info: [],
            mygroom_reser: [],
            down_mygroom_reser: [],
            mygroom_using: [],
            //현재 연장상품이 존재하는지 아닌지를 판단할 flag
            continue_seat_purchase_history_flag: false,
            // 연장 등록되어있는 상품의 정보
            already_continue_seat_purchase_history_id: '',
            already_exten_seat_item_time: '',
            useinfo_exten_seat_item_time: '',
            useinfo_exten_seat_item_name: '',
            //내좌석 종료시간
            my_seat_end_time: '',
            store_name: '',
            store_pay_yn: this.$store.getters['getStore_pay_info'],
            groom_reservation_data: {},
            mygroom_history_info: [], //250724 추가
        }
    },
    methods: {
        payment_mileage() {
            this.$router.push('/payment_mileage');
        },
        //오늘날짜 리턴함수
        get_today() {
            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth() + 1; //January is 0!
            var yyyy = today.getFullYear();
            var h = today.getHours();
            var m = today.getMinutes();

            if (h < 10) {
                h = '0' + h
            }

            if (m < 10) {
                m = '0' + m
            }

            if (dd < 10) {
                dd = '0' + dd
            }

            if (mm < 10) {
                mm = '0' + mm
            }
            var now_date = today = yyyy + '-' + mm + '-' + dd + ' ' + h + ':' + m + ':00';
            return now_date;
        },
        change_password_modal() {
            var router = this.$router;
            router.push('/password_edit')
        },
        close() {
            var router = this.$router;
            router.push('/front_main')
        },
        payment_mileage() {
            this.$router.push('/payment_mileage');
        },
        timeToDateTime(minute, time_type, end_date) {
            var str_left_time = "";
            if (time_type != "" && time_type == "일") {
                // var today = this.get_today();
                // var date1 = new Date(today);
                // var date2 = new Date(end_date += ':00');
                // var mil_time = date2 - date1;

                // var dd = Math.floor((mil_time / (1000 * 60 * 60 * 24)));
                // var hh = Math.floor((mil_time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                // var mm = Math.floor((mil_time % (1000 * 60 * 60)) / (1000 * 60));
                // str_left_time = dd + "일" +' '+ hh + "시간" +' '+ mm + "분";
                // 기간권 같은 경우 남은 시간을 보여줄 필요가 없음.
                str_left_time = '-'

            } else {

                if (isNaN(minute)) {
                    str_left_time = '';
                } else {
                    var hour = parseInt(parseInt(minute) / 60);
                    var min = parseInt(parseInt(minute) % 60);
                    if (hour != 0) {
                        str_left_time = hour + "시간";
                    }
                    if (min != 0) {
                        if (str_left_time == "") {
                            str_left_time = min + "분";
                        } else {
                            str_left_time += " " + min + "분"
                        }

                    } else {
                        if (str_left_time == "") {
                            // str_left_time = "0분";
                            str_left_time = "-";
                        }
                    }
                }

            }

            return str_left_time;
        },
        go_reservation_pay(item){
            if(this.store_pay_yn){
                this.$store.commit('set_reservation_info', item);
                if(this.$store.getters.get_reservation_info.groom_reservation_id > 0){
                    this.$router.push('/Payment_reservation');
                }
            }else{
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `관리자에게 문의하세요.`,
                    router: '',
                };
                this.$store.commit('set_popup_type', alert_param);
            }
        },
        store_change(){
            this.$router.push('/store');
        },
        test(){
            const alert_param = {
                        code: 175
                    };
            this.$store.commit('set_popup_type', alert_param)
        },
        getDateFormat(date){
            var year = date.getFullYear();              //yyyy
            var month = (1 + date.getMonth());          //M
            month = month >= 10 ? month : '0' + month;  //month 두자리로 저장
            var day = date.getDate();                   //d
            day = day >= 10 ? day : '0' + day;          //day 두자리로 저장
            return  year + '-' + month + '-' + day;
        },
        getTimeFormat(today){
            let hours = today.getHours() >= 10 ? today.getHours() : '0' + today.getHours(); // 시
            let minutes = today.getMinutes() >= 10 ? today.getMinutes() : '0' + today.getMinutes(); // 분
            let seconds =  today.getSeconds() >= 10 ? today.getSeconds() : '0' + today.getSeconds();  // 초
            return hours + ':' + minutes + ':' + seconds;
        },
        allGroomReservation(){
            // this.mygroom_reser
            // this.mygroom_using
            this.groom_reservation_data = {
                'reser' : this.mygroom_reser,
                'using' : this.mygroom_using
            }
            // this.$emit("groom_reservation_list", this.groom_reservation_data);

            this.$refs.pop.get_groom_reservation_data(this.groom_reservation_data);

            const alert_param = {
                code: this.$store.getters['get_popup_code'].POPUP_GROOM_RESERVATION_LISt,
                message: ``,
                router: '',
            };
            this.$store.commit('set_popup_type', alert_param);
            return;
        }

    },
    mounted() {        
        this.$store.commit('set_price_page_tab_code', {
            'tab_code': ''
        });
        // 내 상품 목록
        const myproduct_list_type = config.REQ_MYPAGE_SEAT_GOODS_GET_LIST;
        // 내 쿠폰목록
        const mycoupon_list_type = config.REQ_MYPAGE_COUPON_GOODS_GET_LIST;
        // 내 좌석 정보
        const myseat_info_type = config.REQ_MYPAGE_SEAT_GET;
        //  내 사물함 정보
        const mylocker_info_type = config.REQ_MYPAGE_LOCKER_GET;
        // 내 그룹룸 상품목록   =>  Unknown column 'B.groom_id' error 있음
        const mygroom_info_type = config.REQ_MYPAGE_GROOM_GOODS_GET_LIST;
        // 내 그룹룸 예약 목록
        const mygroom_reser_type = config.REQ_MYPAGE_GROOMRESERV_GET_LIST;
        // 내 좌석 사용정보
        const seat_use_type = config.REQ_SEAT_USE_GET_LIST;
        // 내 라커 사용정보
        const locker_use_type = config.REQ_LOCKER_USE_GET;
        // 250724 내 그룹룸 이용내역 추가
        const mygroom_history_type = config.REQ_MYPAGE_GROOMHISTORY_GET_LIST;

        const request_data = {
            data: {}
        };

        // 'user_id' 이후 store.js 에서 값 가져오도록 수정

        this.store_name = this.$store.getters['getStoreInfo']['store_name'];
        var get_my_seat_data = this.$store.getters['get_my_seat_data'];
        this.my_seat_end_time = get_my_seat_data[0].use_end_datetime;
        
        var user_data = this.$store.getters['getUser'];
        if (!this.$store.state.login_chk) {
            var router = this.$router;
            // router.push('/login');
            this.$store.commit('set_Last_URL', '/mypage');
            return;
        }
        const my_info_data = {
            'user_id': user_data.user_id
        };
        var self = this;
        // 사용중인 좌석 남은 시간 업데이트
        const seat_use_left_time_update = config.REQ_SEAT_USE_LEFT_TIME;
        this.$store.dispatch(seat_use_left_time_update.action_name, {
            type: seat_use_left_time_update,
            data: {}
        }).then(response => {
            // 여러건 호출
            Promise.all(
                [
                    this.$store.dispatch(myproduct_list_type.action_name, {
                        type: myproduct_list_type,
                        data: my_info_data
                    }),
                    this.$store.dispatch(mycoupon_list_type.action_name, {
                        type: mycoupon_list_type,
                        data: my_info_data
                    }),
                    this.$store.dispatch(myseat_info_type.action_name, {
                        type: myseat_info_type,
                        data: my_info_data
                    }),
                    this.$store.dispatch(mylocker_info_type.action_name, {
                        type: mylocker_info_type,
                        data: my_info_data
                    }),
                    this.$store.dispatch(mygroom_info_type.action_name, {
                        type: mygroom_info_type,
                        data: my_info_data
                    }),
                    this.$store.dispatch(mygroom_reser_type.action_name, {
                        type: mygroom_reser_type,
                        data: my_info_data
                    }),
                    this.$store.dispatch(seat_use_type.action_name, {
                        type: seat_use_type,
                        data: request_data
                    }),
                    this.$store.dispatch(seat_use_type.action_name, {
                        type: locker_use_type,
                        data: request_data
                    }),
                    // 250724 내 그룹룸 이용내역 관련으로 추가
                    this.$store.dispatch(mygroom_history_type.action_name, {
                        type: mygroom_history_type,
                        data: request_data
                    })
                ]
            ).then(responseList => {
                var locker_exten_chkFlag = false;
                if(responseList[6].data.length > 0){
                    if (responseList[6].data[0].continue_seat_purchase_history_id != null) {
                    this.already_continue_seat_purchase_history_id = responseList[6].data[0].continue_seat_purchase_history_id;
                    this.already_exten_seat_item_time = responseList[6].data[0].continue_use_hours_plan;
                    this.continue_seat_purchase_history_flag = true;
                    } else {
                        this.continue_seat_purchase_history_flag = false;
                    }
                }
                if(responseList[7].data.length > 0){
                    if (responseList[7].data[0].continue_locker_purchase_history_id != null) {
                        locker_exten_chkFlag = true;
                    }
                }


                // 응답 - 요청 순서별 응답 array
                this.my_productList = responseList[0].data;                                                
                if (this.my_productList != null && this.my_productList.length != 0) {
                    for (var i = 0; i < this.my_productList.length; i++) {
                        if(this.my_productList[i].name == '사용중'){
                            this.$store.commit('setGoods_name', {
                                seat_goods_name : this.my_productList[i].goods_group_name
                            });
                        }
                        if (this.continue_seat_purchase_history_flag) { // 연장상품이 있다면 ,
                            if (this.already_continue_seat_purchase_history_id == this.my_productList[i].seat_purchase_history_id) { // 연장상품의 id와 내가가지고 있는 상품의 id가 같다면,
                                this.useinfo_exten_seat_item_name = this.my_productList[i].goods_group_name;
                                if (this.my_productList[i].use_time_settings_yn == 1) { // 시간사용설정 여부가 y 인 상품이라면,
                                    // 시간계산 로직 (해당 좌석의 종료시간에 맞추어 연장등록된 use hours plan 값을 이용해 예상종료시간을 계산)
                                    let time = new Date(get_my_seat_data[0].use_end_datetime).setMinutes(new Date(get_my_seat_data[0].use_end_datetime).getMinutes() + this.already_exten_seat_item_time);
                                    let tDate = new Date(time);

                                    let dd = tDate.getDate();
                                    let mm = tDate.getMonth() + 1; //January is 0!
                                    let yyyy = tDate.getFullYear();
                                    let hour = tDate.getHours();
                                    let min = tDate.getMinutes();
                                    if (hour < 10) {
                                        hour = '0' + hour;
                                    }
                                    if (min < 10) {
                                        min = '0' + min;
                                    }

                                    if (dd < 10) {
                                        dd = '0' + dd;
                                    }
                                    if (mm < 10) {
                                        mm = '0' + mm;
                                    }
                                    let currentTime = hour + ":" + min + "";
                                    this.useinfo_exten_seat_item_time = yyyy + '-' + mm + '-' + dd + ' ' + currentTime;

                                } else {
                                    let time;
                                    if (this.my_productList[i].left_time > 0) {
                                        time = new Date(get_my_seat_data[0].use_end_datetime).setMinutes(new Date(get_my_seat_data[0].use_end_datetime).getMinutes() + this.my_productList[i].left_time);
                                    } else {
                                        time = new Date(get_my_seat_data[0].use_end_datetime).setDate(new Date(get_my_seat_data[0].use_end_datetime).getDate() + this.my_productList[i].day_count);
                                    }

                                    let tDate = new Date(time);
                                    let dd = tDate.getDate();
                                    let mm = tDate.getMonth() + 1; //January is 0!
                                    let yyyy = tDate.getFullYear();
                                    let hour = tDate.getHours();
                                    let min = tDate.getMinutes();
                                    if (hour < 10) {
                                        hour = '0' + hour;
                                    }
                                    if (min < 10) {
                                        min = '0' + min;
                                    }

                                    if (dd < 10) {
                                        dd = '0' + dd;
                                    }
                                    if (mm < 10) {
                                        mm = '0' + mm;
                                    }
                                    let currentTime = hour + ":" + min + "";
                                    this.useinfo_exten_seat_item_time = yyyy + '-' + mm + '-' + dd + ' ' + currentTime;
                                }
                            }
                        }
                        var left_time = 0;
                        if(this.my_productList[i].end_time_yn == 1){
                            var use_start_date = this.$moment();
                            var use_end_date = this.$moment(this.my_productList[i].use_end_datetime);
                            left_time = use_end_date.diff(use_start_date, 'minutes') + 1;
                        }else{
                            left_time = this.my_productList[i].left_time;
                        }
                        var time_type = this.my_productList[i].time_type;
                        var end_date = this.my_productList[i].use_end_datetime;
                        // 260108 1일시간권 자리이동시 잔여시간 다르게 보이는 이슈로 수정함
                        if(this.my_productList[i].seat_purchase_history_id === response.data.seat_purchase_history_id){
                            // 시간충전권 이용중일때는 이용중인 데이터 기준 계산
                            if(response.data.end_term_yn == 1){
                                var use_start_date = this.$moment();
                                var use_end_date = this.$moment(response.data.use_end_datetime);
                                left_time = use_end_date.diff(use_start_date, 'minutes') + 1;
                            }
                        }
                        var date_time = this.timeToDateTime(left_time, time_type, end_date); 
                        /* 260108 수정 전
                        var date_time = this.my_productList[i].seat_purchase_history_id === response.data.seat_purchase_history_id ?
                            this.timeToDateTime(response.data.minute, time_type, end_date) : this.timeToDateTime(left_time, time_type, end_date); */
                        this.my_productList[i].str_left_time = date_time;
                    }
                }
                this.my_couponList = responseList[1].data;
                if (this.my_couponList != null && this.my_couponList.length != 0) {
                    for (var i = 0; i < this.my_couponList.length; i++) {
                        if(this.my_couponList[i].name == '사용중'){                            
                            this.$store.commit('setGoods_name', {
                                seat_goods_name : this.my_couponList[i].goods_group_name
                            });
                        }

                        if (this.continue_seat_purchase_history_flag) { // 연장상품이 있다면 ,
                            if (this.already_continue_seat_purchase_history_id == this.my_couponList[i].seat_purchase_history_id) { // 연장상품의 id와 내가가지고 있는 상품의 id가 같다면,
                                this.useinfo_exten_seat_item_name = this.my_couponList[i].goods_group_name;
                                if (this.my_couponList[i].use_time_settings_yn == 1) { // 시간사용설정 여부가 y 인 상품이라면,
                                    // 시간계산 로직 (해당 좌석의 종료시간에 맞추어 연장등록된 use hours plan 값을 이용해 예상종료시간을 계산)
                                    let time = new Date(get_my_seat_data[0].use_end_datetime).setMinutes(new Date(get_my_seat_data[0].use_end_datetime).getMinutes() + this.already_exten_seat_item_time);
                                    let tDate = new Date(time);

                                    let dd = tDate.getDate();
                                    let mm = tDate.getMonth() + 1; //January is 0!
                                    let yyyy = tDate.getFullYear();
                                    let hour = tDate.getHours();
                                    let min = tDate.getMinutes();
                                    if (hour < 10) {
                                        hour = '0' + hour;
                                    }
                                    if (min < 10) {
                                        min = '0' + min;
                                    }

                                    if (dd < 10) {
                                        dd = '0' + dd;
                                    }
                                    if (mm < 10) {
                                        mm = '0' + mm;
                                    }
                                    let currentTime = hour + ":" + min + "";
                                    this.useinfo_exten_seat_item_time = yyyy + '-' + mm + '-' + dd + ' ' + currentTime;

                                } else {
                                    let time;

                                    if (this.my_couponList[i].left_time > 0) {
                                        time = new Date(get_my_seat_data[0].use_end_datetime).setMinutes(new Date(get_my_seat_data[0].use_end_datetime).getMinutes() + this.my_couponList[i].left_time);
                                    } else {
                                        time = new Date(get_my_seat_data[0].use_end_datetime).setDate(new Date(get_my_seat_data[0].use_end_datetime).getDate() + this.my_couponList[i].end_day_count);
                                    }

                                    let tDate = new Date(time);
                                    let dd = tDate.getDate();
                                    let mm = tDate.getMonth() + 1; //January is 0!
                                    let yyyy = tDate.getFullYear();
                                    let hour = tDate.getHours();
                                    let min = tDate.getMinutes();
                                    if (hour < 10) {
                                        hour = '0' + hour;
                                    }
                                    if (min < 10) {
                                        min = '0' + min;
                                    }

                                    if (dd < 10) {
                                        dd = '0' + dd;
                                    }
                                    if (mm < 10) {
                                        mm = '0' + mm;
                                    }
                                    let currentTime = hour + ":" + min + "";
                                    this.useinfo_exten_seat_item_time = yyyy + '-' + mm + '-' + dd + ' ' + currentTime;
                                }
                            }
                        }
                        // this.my_couponList[i].str_use_total_hours = this.timeToDateTime(this.my_couponList[i].use_total_hours/60, '');
                        // this.my_couponList[i].str_left_hours = this.timeToDateTime(this.my_couponList[i].left_hours/60, '');
                        var left_time = 0;
                        if(this.my_couponList[i].end_time_yn == 1){
                            var use_start_date = this.$moment();
                            var use_end_date = this.$moment(this.my_couponList[i].use_end_datetime);
                            left_time = use_end_date.diff(use_start_date, 'minutes') + 1;
                        }else{
                            left_time = this.my_couponList[i].left_time;
                        }
                        var time_type = this.my_couponList[i].time_type;
                        var end_date = this.my_couponList[i].use_end_datetime;
                        //var date_time = this.my_couponList[i].seat_purchase_history_id === response.data.seat_purchase_history_id ? this.timeToDateTime(response.data.minute, time_type, end_date) : this.timeToDateTime(left_time, time_type, end_date);
                        
                        // 260108 1일시간권 자리이동시 잔여시간 다르게 보이는 이슈로 수정함
                        if(this.my_couponList[i].seat_purchase_history_id === response.data.seat_purchase_history_id){
                            // 시간충전권 이용중일때는 이용중인 데이터 기준 계산
                            if(response.data.end_term_yn == 1){
                                var use_start_date = this.$moment();
                                var use_end_date = this.$moment(response.data.use_end_datetime);
                                left_time = use_end_date.diff(use_start_date, 'minutes') + 1;
                            }
                        }
                        
                        var date_time = this.timeToDateTime(left_time, time_type, end_date);
                        this.my_couponList[i].str_left_time = date_time;
                    }
                }
                this.myseat_info = responseList[2].data;
                this.mylocker_info = responseList[3].data;
                this.mygroom_info = responseList[4].data;

                if (this.mygroom_info != null && this.mygroom_info.length != 0) {
                    for (var i = 0; i < this.mygroom_info.length; i++) {
                        if(this.mygroom_info[i].name == '사용중'){                            
                            this.$store.commit('setGoods_name', {
                                groom_goods_name : this.mygroom_info[i].goods_group_name
                            });
                        }

                        this.mygroom_info[i].str_use_total_hours = this.timeToDateTime(this.mygroom_info[i].use_total_hours / 60, '');
                        this.mygroom_info[i].str_left_hours = this.timeToDateTime(this.mygroom_info[i].left_hours, '');
                    }
                }
                this.mygroom_reser = responseList[5].data;
                this.mygroom_using = responseList[5].data2;
                this.mygroom_reser.index = this.mygroom_using.length;


                /* if(this.mygroom_reser.length > 5){
                    let date = new Date();
                    let today = this.getDateFormat(date);
                    let datetime = today+ ' '+ this.getTimeFormat(date);
                    let y = today.split('-')[0];
                    let m = today.split('-')[1];
                    let d = today.split('-')[2];
                    m = parseInt(m) - 1;
                    var sDate = new Date(y, m, d);
                    sDate.setDate(sDate.getDate() + 3);
                    var limitDateTime = this.getDateFormat(sDate)+ ' 23:59:59';
                    
                    for(let i=0; i<this.mygroom_reser.length; i++){
                        
                        // 3일이내 데이터
                        if(datetime <= this.mygroom_reser[i].start_datetime && limitDateTime >= this.mygroom_reser[i].start_datetime){
                            this.down_mygroom_reser.push(this.mygroom_reser[i]);
                        }
                    }
                    if(this.down_mygroom_reser.length > 0){
                        this.down_mygroom_reser.index = this.mygroom_using.length;
                    }
                }*/
                

                // 라커 사용정보 요청 flag in
                if(locker_exten_chkFlag){
                    const locker_info_type = config.REQ_LOCKER_GOODS_GET;
                    const data_info = {
                        data: {'locker_purchase_history_id':responseList[7].data[0].continue_locker_purchase_history_id}
                    };
                    this.$store.dispatch(locker_use_type.action_name, {
                        type: locker_info_type,
                        data: data_info
                    }).then(response => {

                        var product_st = this.mylocker_info[0].use_start_datetime;
                        var product_end = this.mylocker_info[0].use_end_datetime;
                        var sdt = new Date(product_st);
                        var edt = new Date(product_end);

                        let time = new Date(product_end).setDate(new Date(product_end).getDate()+Number(response.data[0].left_date))
                        let tDate = new Date(time);
                        let dd = tDate.getDate();
                        let mm = tDate.getMonth() + 1; //January is 0!
                        let yyyy = tDate.getFullYear();
                        let hour = tDate.getHours();
                        let min = tDate.getMinutes();

                        if(hour < 10){
                            hour = '0'+ hour;
                        }
                        if(min < 10){
                            min = '0'+min;
                        }
                        if (dd < 10) {
                            dd = '0' + dd;
                        }
                        if (mm < 10) {
                            mm = '0' + mm;
                        }

                        let currentTime = hour + ":" + min + "";
                        let cal_date = yyyy + '-' + mm + '-' + dd + ' ' + currentTime;

                        this.mylocker_info[0].use_end_datetime = cal_date;
                        // this.continue_locker_end_time = cal_date;

                    }).catch(function (error) {
                    console.log('error=============>', error);
                    })
                }
                

                //250724 내 그룹룸 이용내역 추가
                this.mygroom_history_info = responseList[8].data;

            })
        }).catch(function (error) {
            console.log('error=============>', error);
        });

        this.$store.commit('set_main_page_top_menu_code', {
            'menu_code': "MYPAGE"
        });
    }
}
</script>

<style>
th {
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/page/mypage.vue